import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Wrapper = props => (

  <div {...css(props.styles.wrapper
  //,(!!props.children && !! !!props.children[0].props.widgets && !!props.children[0].props.widgets["ATTIVA_REVOCA_FIRMA"])? '':''
  )} >
  {props.children}
  </div>
)

Wrapper.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Wrapper)



// WEBPACK FOOTER //
// ./components/wrapper/index.js